module.exports = __webpack_public_path__ + "img/service2@2x.390f608f.png";